import React from 'react';
import '@creativebulma/bulma-badge/dist/bulma-badge.css';

const BadgeButton = ({ link, number, name }) => {
  return (
    <div>
      <a className="button is-link" href={link}>
        {number > 0 && <span title="Badge top right" className="badge">{number}</span>}
        {name}
      </a>
    </div>
  )
}

export default BadgeButton;